export const getSupportEmail = (): string => {
  const currentDomain = window.location.hostname;

  if (currentDomain.includes('stopclaims')) {
    return 'stopclaims-support@triexcms.com';
  }

  // utmc and default fallback
  return 'utmc-support@triexcms.com';
};
